// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"549":"0d1ea958","952":"53e98895"}[chunkId] + ".chunk.css";
};